import { CheckedChangedEventHandler } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import { useIntl } from '@/intl'
import { ShowMore } from '@/scopes/common/components/ShowMoreUDS'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'
import ListFilterItem from '@/scopes/search/search/pages/SearchPage/components/Filters/ListFilterItem'

export function SkiAreaSlopeKmsFilter() {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { options, selectedValue, isFetching, setSelection } = useSelectFilter('SkiAreaSlopeKms')

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      setSelection(value)
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'ski area slopes kms',
          result: value,
        }),
      )
    }
    else {
      setSelection(undefined)
    }
  }

  if (isEmpty(options))
    return null

  return (
    <div data-qa="ski-area-slope-kms-filter">
      <Typography variant="body-m-regular-snug" forwardedAs="h3" className="my-2">
        {intl.formatMessage({ id: 'search_filter_ski_area_slope_kms_label' })}
      </Typography>
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
        visibleItems={4}
      >
        {options.map(({ name, value, resultsCount }) => (
          <ListFilterItem.Checkbox
            key={name}
            label={name}
            counter={resultsCount}
            checked={selectedValue === value}
            value={value}
            onChange={handleFilterChange}
            disabled={isFetching}
            data-qa="ski-area-slope-kms-filter-option"
            data-qa-value={value?.toLowerCase()}
          />
        ))}
      </ShowMore>
    </div>
  )
}
